import React, { ReactNode } from 'react';
import { renderMultiline } from '../utils/text';

interface Props {
  image: string;
  eyebrow: string;
  title: string;
  text?: string;
  children?: ReactNode;
}

const CtaBand: React.FC<Props> = ({ image, eyebrow, title, text, children }) => (
  <section className="band">
    <div className="band__topo" style={{ backgroundImage: `url('${image}')` }} />
    <span className="eyebrow on-dark" style={{ position: 'relative' }}>{eyebrow}</span>
    <h2 style={{ marginTop: '.4em' }}>{renderMultiline(title)}</h2>
    {text && <p>{text}</p>}
    {children}
  </section>
);

export default CtaBand;
